// extracted by mini-css-extract-plugin
export default {"wrapper":"x1-z","play":"y1-z"};